import { api } from "apiServer"
import { Layout } from "components/common"
import { Fragment, useEffect, useRef, useState } from "react"
import CardTopic from "components/CardTopic"

let calling = false

function Component({ lists, id }) {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState(lists)
  const pageNum = useRef(1)
  const maxCount = useRef(50)
  useEffect(() => {
    function onScroll() {
      if (window.scrollY + window.innerHeight > (document.body.scrollHeight * 6) / 7) {
        if (!calling) {
          setLoading(true)
        }
      }
    }

    window.addEventListener("scroll", onScroll)
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])

  async function fetch() {
    try {
      pageNum.current = pageNum.current + 1
      const { data, count } = await api.getFullCategoryChild(null, id, {
        page_num: pageNum.current,
        page_size: 24
      })
      maxCount.current = count
      setRows([...rows, ...data])
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
      calling = false
    }
  }

  useEffect(() => {
    if (loading && maxCount.current > rows.length) fetch()
  }, [loading])

  const { name, thumbnail, display_type, type_block } = lists
  return (
    <>
      <section className="py-12 max-w-screen-xl mx-auto px-12 2xl:px-0">
        <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">{name}</h2>
        <div className="mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6">
          {rows?.contents?.length > 0 &&
            rows?.contents?.map((item) => {
              const { id, is_live } = item

              return (
                <Fragment key={id}>
                  <div>
                    <CardTopic {...item} showTime={is_live ? true : false} />
                  </div>
                </Fragment>
              )
            })}
        </div>
      </section>
    </>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps({ req, query, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let lists = [],
    video = {}
  const { cookies } = req
  const { id } = query
  try {
    const { data, block } = await api.getFullCategoryChild(cookies?.accessToken, id, {
      page_num: 1,
      page_size: 24
    })
    lists = data
  } catch (error) {
    // console.log(error.response)
  }
  return { props: { lists, id } }
}
